import { render } from "./GameBoard.vue?vue&type=template&id=7115f0aa"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"

import "./GameBoard.vue?vue&type=style&index=0&id=7115f0aa&lang=css"
script.render = render

export default script